import { map, drawSource } from './map.js';
import { stationsLayer, stationsSource, clusterSource } from './stations.js';
import { updateWindSpeeds } from './windSimulation.js';
import { popupOverlay, showPopup, hidePopup } from './popup.js';
import Draw from 'ol/interaction/Draw.js';
import Select from 'ol/interaction/Select.js';
import { singleClick } from 'ol/events/condition.js';

// Añadir capas y overlays
map.addLayer(stationsLayer);
map.addOverlay(popupOverlay);

// Panel de alertas (debe estar en tu HTML)
const alertStatus = document.getElementById('alert-status');
const zoneStatus = document.getElementById('zone-status');
const alertWarning = document.getElementById('alert-warning');
const drawBtn = document.getElementById('draw-btn');

// Interacciones de selección
const selectClick = new Select({
    condition: singleClick,
    layers: [stationsLayer],
    style: null,
});
map.addInteraction(selectClick);

selectClick.on('select', function(event) {
    const selectedFeatures = event.selected;
    if (selectedFeatures.length > 0) {
        const feature = selectedFeatures[0];
        const originalFeatures = feature.get('features');
        const stationFeature = originalFeatures ? originalFeatures[0] : feature;
        const stationData = stationFeature.getProperties();
        const stationName = stationData['NOMBRE'];
        const windSpeed = stationData['windSpeed'];
        const coordinate = feature.getGeometry().getCoordinates();
        showPopup(stationName, windSpeed, coordinate);
    } else {
        hidePopup();
    }
});

// Lógica de simulación de viento y actualización de estado
function updatePanelStatus() {
    // Actualiza el número de estaciones
    alertStatus.textContent = `Estado: Actualizadas ${stationsSource.getFeatures().length} estaciones`;

    // Si hay zona de monitoreo, calcula cuántas estaciones incluye y si hay alerta
    if (monitoringZone) {
        const features = stationsSource.getFeatures();
        let count = 0;
        let alerta = false;
        features.forEach(f => {
            if (monitoringZone.intersectsExtent(f.getGeometry().getExtent())) {
                count++;
                if (f.get('windSpeed') >= 90) alerta = true;
            }
        });
        zoneStatus.textContent = `Zona monitorizada con ${count} estaciones`;
        alertWarning.style.display = alerta ? 'block' : 'none';
    } else {
        zoneStatus.textContent = 'Zona monitorizada: ninguna';
        alertWarning.style.display = 'none';
    }
}

// Simulación de viento periódica
stationsSource.on('featuresloadend', function() {
    updateWindSpeeds(stationsSource, clusterSource);
    updatePanelStatus();
    setInterval(() => {
        updateWindSpeeds(stationsSource, clusterSource);
        updatePanelStatus();
    }, 5000);
});

// Dibujo de zona de monitoreo
let drawInteraction = null;
let monitoringZone = null;

function activateDrawInteraction() {
    if (drawInteraction) {
        map.removeInteraction(drawInteraction);
    }
    drawSource.clear();
    monitoringZone = null;
    updatePanelStatus();

    drawInteraction = new Draw({
        source: drawSource,
        type: 'Polygon',
    });
    map.addInteraction(drawInteraction);

    drawInteraction.on('drawend', function(event) {
        monitoringZone = event.feature.getGeometry();
        map.removeInteraction(drawInteraction);
        drawInteraction = null;
        updatePanelStatus();
    });
}

// Asignar evento al botón del panel
drawBtn.onclick = activateDrawInteraction;

// Inicializar panel al cargar
updatePanelStatus();